import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { encryptPayload } from "./encrypt";

export const getDashboardConfiguration = createAsyncThunk(
  "fetchApi/getDashboardConfiguration",
  async (id) => {
    const req = `${BASE_URL}/dashboard-configuration/getDashboardConfiguration${id ? "/" + id : ""}`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const result = await apiRequest(req, options, true);
      return result.data;
    } catch (err) {
      // // console.log(err);
    }
  }
);

export const getDashboardListDetails = createAsyncThunk(
  "fetchApi/getDashboardListDetails",
  async (params) => {
    const req = `${BASE_URL}/dashboard-configuration/getDashboardListDetails`;
    let req_body = {
      body: params,
    };
    const encryptedBodyRes = await encryptPayload("", req_body, true, true);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };

    try {
      const result = await encryptPayload(req, options, false, true, true);
      return result.data;
    } catch (err) {
      // // console.log(err);
    }
  }
);

export const downloadMISReport = async (params) => {
  const req = `${BASE_URL}/dashboard-configuration/downloadMISReport`;
  let req_body = {
    body: params,
  };
  const encryptedBodyRes = await encryptPayload("", req_body, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    const result = await encryptPayload(req, options, false, true, true);
    return result.data;
  } catch (err) {
    console.log(err);
  }
}

export const getAllUsersByOrg = createAsyncThunk(
  "fetchApi/getAllUsersByOrg",
  async (params) => {
    const req = `${BASE_URL}/organisation/getAllUsersByOrgId`;
    let req_body = {
      body: params,
    };
    const encryptedRequest = await encryptPayload("", req_body, true, true);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedRequest),
    };

    try {
      const result = await encryptPayload(req, options, false, true, true);
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const getAllRolesByOrg = createAsyncThunk(
  "fetchApi/getAllRolesByOrg",
  async (params) => {
    const req = `${BASE_URL}/organisation/getAllRolesByOrgId`;
    let req_body = {
      body: params,
    };
    const encryptedBodyRes = await encryptPayload("", req_body, true, true);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };

    try {
      const result = await encryptPayload(req, options, false, true, true);
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const updateDashboardFilter = createAsyncThunk(
  "fetchApi/getAllRolesByOrg",
  async (params) => {
    const req = `${BASE_URL}/dashboard-configuration/updateDashboardFilter`;
    let req_body = {
      body: params,
    };
    const encryptedBodyRes = await encryptPayload("", req_body, true, true);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };

    try {
      const result = await encryptPayload(req, options, false, true, true);
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const getDashboardFilters = createAsyncThunk(
  "fetchApi/getDashboardFilters",
  async ({role_id, user_id, module_id}) => {
    const req = `${BASE_URL}/dashboard-configuration/getDashboardFilters/${role_id}/${user_id}/${module_id}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const result = await apiRequest(req, options, true);
      return result;
    } catch (err) {
      // // console.log(err);
    }
  }
);

export const checkAndChangeDefault = createAsyncThunk(
  "fetchApi/getAllRolesByOrg",
  async (params) => {
    const req = `${BASE_URL}/dashboard-configuration/checkAndChangeDefault`;
    let req_body = {
      body: params,
    };
    const encryptedBodyRes = await encryptPayload("", req_body, true, true);

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encryptedBodyRes),
    };

    try {
      const result = await encryptPayload(req, options, false, true, true);
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const getFilterDropdownList = createAsyncThunk(
  "fetchApi/getAllRolesByOrg",
  async (params) => {
    const req = `${BASE_URL}/dashboard-configuration/getFilterDropdownList`;
    // let req_body = {
    //   body: params,
    // };
    // const encryptedBodyRes = await encryptPayload("", req_body, true, true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    };

    try {
      // const result = await encryptPayload(req, options, false, true, true);
      const result = await apiRequest(req, options, true);
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);
